// extracted by css-extract-rspack-plugin
export default {"root":"root-v9djIm"};